import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const SpreadsheetHeader = () => {
    const currentLocation = (): string => {
        const urlInfo = globalThis.location.href.split('/').reduce((state, curr) => {
            if (curr == 'spreadsheets#' || state.length > 0) state.push(curr)
            return state
        }, [])

        return String(urlInfo[1]).toLowerCase()
    }
    const [state, setState] = useState<{ tab: string }>({ tab: currentLocation() })

    const handleTab = (tab: string): void => {
        setState({ tab })
    }

    return (
        <StyledSpreadsheetHeader>
            <div className={'HeaderTitle'}>
                <span>STATIC DATA</span>
                <label>Spreadsheets Uploader</label>
            </div>
            <div className={'HeaderTab'}>
                <ul>
                    <Link
                        to={{
                            pathname: '/'
                        }}
                    >
                        <li
                            className={state.tab === 'databases' ? `HeaderTab--listItem--selected` : null}
                            onClick={() => handleTab('databases')}
                        >
                            Databases
                        </li>
                    </Link>
                    <Link
                        to={{
                            pathname: '/groups'
                        }}
                    >
                        <li
                            className={state.tab === 'groups' ? `HeaderTab--listItem--selected` : null}
                            onClick={() => handleTab('groups')}
                        >
                            Groups
                        </li>
                    </Link>
                    <Link to={{ pathname: '/groups-sftp' }}>
                        <li
                            className={state.tab === 'groups-sftp' ? `HeaderTab--listItem--selected` : null}
                            onClick={() => handleTab('groups-sftp')}
                        >
                            Groups SFTP
                        </li>
                    </Link>
                    <Link to={{ pathname: '/groups-s3' }}>
                        <li
                            className={state.tab === 'groups-s3' ? `HeaderTab--listItem--selected` : null}
                            onClick={() => handleTab('groups-s3')}
                        >
                            Groups S3
                        </li>
                    </Link>
                </ul>
            </div>
        </StyledSpreadsheetHeader>
    )
}

const StyledSpreadsheetHeader = styled.div`
    background-color: var(--gray-200);
    width: 100%;
    .HeaderTitle {
        display: flex;
        flex-direction: row;
        border-bottom: 2px solid var(--gray-300);
        padding: 15px 10% 15px 10%;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;

        span {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;

            color: var(--gray-600);
            padding-right: 8px;
            border-right: 2px solid var(--gray-300);
        }

        label {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            padding-left: 10px;

            color: var(--gray-600);
        }
    }

    .HeaderTab {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: auto;
        ul {
            margin: auto;
            padding: 0;
            overflow: hidden;
            width: 80%;
            height: 36px;
        }
        &--listItem {
            &--selected {
                border-bottom: 2px solid var(--blue-500);
            }
        }
        li {
            float: left;
            font-size: 16px;
            color: var(--gray-600);
            font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            margin-top: 12px;
            margin-right: 32px;
        }
        li:hover {
            color: var(--blue-500);
        }
    }
`
